module.exports = __webpack_public_path__ + "static/media/splashLogo.ee3c1e09.png";